export class EndpointModel {
  _id?: any;
  uuid: string;
  contact_hdr_uuid?: string;
  type: string;
  id: string;
  provider_property: ProviderProperty;
  create_date: Date;
  update_date: Date;
  created_by: string;
  updated_by: string;
  revision: string;
  status: string;
  vrsn: string;
  contact_type: string;
  username: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  company_address?: string;
  property_json?: PropertyJson;
  is_blocked?: boolean;
}

export class ProviderProperty {
  provider?: string;
  access_id?: string;
  auth_token?: string;
  api_key?: string;
  api_token?: string;
  application_id?: string;
  refresh_token?: string;
  expires_in?: string;
  refresh_expires_in?: string;
}

export class PropertyJson{
  enableRecording?: boolean;
}
